(function () {
  if (window.__unitMainBannerParallaxInit) {
    window.__unitMainBannerParallaxInit();
    return;
  }

  var mediaQuery = window.matchMedia('(min-width: 750px)');
  var ticking = false;

  function update() {
    ticking = false;
    var containers = document.querySelectorAll('[data-unit-main-banner-parallax="true"]');
    if (!containers.length) {
      return;
    }

    if (mediaQuery.matches) {
      containers.forEach(function (container) {
        container.style.removeProperty('--unit-main-banner-parallax-shift');
      });
      return;
    }

    containers.forEach(function (container) {
      var shift = -container.getBoundingClientRect().top;
      container.style.setProperty('--unit-main-banner-parallax-shift', shift + 'px');
    });
  }

  function requestTick() {
    if (ticking) {
      return;
    }
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick);
  document.addEventListener('shopify:section:load', requestTick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', requestTick, { once: true });
  } else {
    requestTick();
  }

  window.__unitMainBannerParallaxInit = requestTick;
})();
